// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// locales
import { LocalizationProvider } from 'src/locales';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
// auth
// import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';
import { AuthProvider, AuthConsumer } from 'src/auth/context/amplify';
import { AppBootstrapProvider } from 'src/contexts/app-bootstrap-context';
import { DemoApolloBoundary } from 'src/components/tour/demo/demo-boundary';
// import { CompanySettingsProvider } from 'src/contexts/company-settings-context'; // Replaced by unified AppBootstrapProvider
// Note: PerformanceThresholdsProvider moved to page-level (DailyOverview, SupplierPerformance) for lazy loading
import { Toaster } from 'src/components/ui/sonner';
import { TooltipProvider } from 'src/components/ui/tooltip';

// ----------------------------------------------------------------------

function AppContent() {
  return (
    <LocalizationProvider>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'light', // 'light' | 'dark'
          themeDirection: 'ltr', //  'rtl' | 'ltr'
          themeContrast: 'default', // 'default' | 'bold'
          themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          // themeStretch: false,
        }}
      >
        <ThemeProvider>
          <MotionLazy>
            <SettingsDrawer />
            <ProgressBar />
            <Toaster />
            <AuthConsumer>
              <DemoApolloBoundary>
                <Router />
              </DemoApolloBoundary>
            </AuthConsumer>
          </MotionLazy>
        </ThemeProvider>
      </SettingsProvider>
    </LocalizationProvider>
  );
}

export default function App() {
  useScrollToTop();

  return (
    <AuthProvider>
      <TooltipProvider>
        <AppBootstrapProvider>
          <AppContent />
        </AppBootstrapProvider>
      </TooltipProvider>
    </AuthProvider>
  );
}
